import moment from "moment";
import { Post } from "../../cores/socialPost/interfaces/api/get-social-posts";

export type HistorySortKey = "relevant" | "published" | "scheduled" | "created";
export type HistorySortOrder = "desc" | "asc";

/** Milis desde epoch, o null si no hay fecha usable */
export function millisForHistorySort(post: Post, key: HistorySortKey): number | null {
  const valid = (iso?: string | null) => {
    if (iso == null || iso === "") return null;
    const m = moment(iso);
    return m.isValid() ? m.valueOf() : null;
  };

  switch (key) {
    case "published":
      return valid(post.postAt);
    case "scheduled":
      return valid(post.scheduleDate);
    case "created": {
      const c = valid(post.createdAt ?? undefined);
      if (c !== null) return c;
      return valid(post.scheduleDate || post.postAt);
    }
    case "relevant":
    default:
      return valid(post.postAt || post.scheduleDate);
  }
}

/** Sin fecha útil: al final de la lista en ambos órdenes */
export function compareSocialPostsByHistorySort(
  aPost: Post,
  bPost: Post,
  key: HistorySortKey,
  order: HistorySortOrder
): number {
  const va = millisForHistorySort(aPost, key);
  const vb = millisForHistorySort(bPost, key);
  const aMissing = va === null;
  const bMissing = vb === null;
  if (aMissing && bMissing) return 0;
  if (aMissing) return 1;
  if (bMissing) return -1;
  const diff = va - vb;
  return order === "desc" ? -diff : diff;
}
